import { Checkbox, Form, Input, Modal, Select, Table, Tag, TimePicker } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import Header from "shared/components/Header";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import cuid from "cuid";
import ScheduleDetail from "../Detail";

const DAYS = [
  { value: "mon", label: "Lun" },
  { value: "tue", label: "Mar" },
  { value: "wed", label: "Mer" },
  { value: "thu", label: "Jeu" },
  { value: "fri", label: "Ven" },
  { value: "sat", label: "Sam" },
  { value: "sun", label: "Dim" },
];

const List = () => {
  const { data, refetch } = useQuery(graphql.queries.CRM_SENDING_SCHEDULES, { variables: {}, fetchPolicy: "network-only" });
  const [createSchedule] = useMutation(graphql.mutations.CREATE_CRM_SENDING_SCHEDULE);
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [form] = Form.useForm();
  const schedules = get(data, "crmSendingSchedules.data") || [];

  const handleCreate = async () => {
    const values = await form.validateFields();
    await createSchedule({
      variables: {
        data: {
          id: cuid(),
          name: values.name,
          timezone: values.timezone || "Europe/Paris",
          days: values.days || ["mon", "tue", "wed", "thu", "fri"],
          startHour: values.startHour || "09:00",
          endHour: values.endHour || "18:00",
          assignedCampaignIds: [],
        },
      },
    });
    form.resetFields();
    setCreateOpen(false);
    await refetch();
  };

  return (
    <>
      <Header key="header" title="Plannings d'envoi" actions={[{ text: "Nouveau planning", onClick: () => setCreateOpen(true), type: "primary", icon: <BiPlus size={18} /> }]} />
      <Table dataSource={schedules} rowKey="id" size="small"
        onRow={(record) => ({
          onClick: () => setSelectedSchedule(record),
          style: { cursor: "pointer" },
        })}
        columns={[
        { title: "Nom", dataIndex: "name", render: (name) => <strong>{name}</strong> },
        { title: "Fuseau horaire", dataIndex: "timezone", width: 180 },
        { title: "Jours", dataIndex: "days", width: 200, render: (days) => (days || []).map((d) => <Tag key={d}>{d}</Tag>) },
        { title: "Heures", width: 120, render: (_, r) => `${r.startHour || "—"} – ${r.endHour || "—"}` },
        { title: "Campagnes", dataIndex: "assignedCampaignIds", width: 100, render: (ids) => (ids || []).length },
      ]} />

      <Modal title="Nouveau planning" open={createOpen} onCancel={() => setCreateOpen(false)} onOk={handleCreate} okText="Créer" cancelText="Annuler">
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Nom" rules={[{ required: true, message: "Le nom est requis" }]}>
            <Input placeholder="Ex: Heures de bureau EU" />
          </Form.Item>
          <Form.Item name="timezone" label="Fuseau horaire" initialValue="Europe/Paris">
            <Select showSearch>
              <Select.Option value="Europe/Paris">Europe/Paris</Select.Option>
              <Select.Option value="America/New_York">America/New_York</Select.Option>
              <Select.Option value="America/Los_Angeles">America/Los_Angeles</Select.Option>
              <Select.Option value="UTC">UTC</Select.Option>
              <Select.Option value="Asia/Tokyo">Asia/Tokyo</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="days" label="Jours" initialValue={["mon", "tue", "wed", "thu", "fri"]}>
            <Checkbox.Group options={DAYS.map((d) => ({ value: d.value, label: d.label }))} />
          </Form.Item>
          <div className="d-flex" style={{ gap: "16px" }}>
            <Form.Item name="startHour" label="Début" style={{ flex: 1 }} initialValue="09:00">
              <Input placeholder="09:00" />
            </Form.Item>
            <Form.Item name="endHour" label="Fin" style={{ flex: 1 }} initialValue="18:00">
              <Input placeholder="18:00" />
            </Form.Item>
          </div>
        </Form>
      </Modal>

      <ScheduleDetail
        schedule={selectedSchedule}
        open={!!selectedSchedule}
        onClose={() => setSelectedSchedule(null)}
        onRefetch={refetch}
      />
    </>
  );
};

export default List;
